
<template>
  <div class="profile-container">

    <!-- =======================
        画面：エラー
      =======================-->
    <div v-if="IsShowErrorContent" class="profile-main-content">
      <h1>
        {{errorMessageTitle}}
        <span>{{errorMessage}}</span>
      </h1>
      <div class="ok-button" @click="GoBack">
          <i class="fas fa-chevron-left"></i>
          ログイン画面へ
        </div>
    </div>

    <!-- =======================
        画面：データ確認中
      =======================-->
    <div v-if="IsCheckingData">
      <p class="checking-data">
        <i class="fas fa-spinner fa-pulse"></i>
        <span class="faa-flash animated">かくにんしています...</span>
      </p>
    </div>

    　<!-- =======================
        画面：新しいパスワードへの変更完了
      =======================-->
      <div v-if="ShowResultOK" class="result-ok-content">
        <i class="far fa-check-circle"></i>
        きみのパスワードは新しいパスワードに変わったよ！
        <div class="ok-button" @click="GoBack">
          <i class="fas fa-chevron-left"></i>
          ログイン画面へ
        </div>
      </div>



    <div v-if="IsShowResetPasswordContent" class="profile-main-content">
      <h1>
        新しいパスワードに変える
        <span>きみのメールアドレス：{{accountEmail}}</span>
      </h1>

      <!-- =======================
        画面：入力
      =======================-->
      <!-- メールの編集 -->
      <div v-if="false === ShowResultOK" class="row-input loading-container">
        <!-- ローディング -->
        <t-loading class="loading-item" :isLoading="IsLoading"></t-loading>

        <!-- 入力欄：新しいパスワード -->
        <t-input
          v-model="ruleForm.newPassword"
          v-validate="'required|min:6|max:20'"
          name="newPassword"
          :enterToEditEnd="false"
          v-bind:class="{disable:IsLoading}"
          :maxlength="20"
          placeholder="新しいパスワードを入れてね"
          inputType="password"
          label="・新しいパスワード"
          iconClassName="fas fa-key"
          :isShowErrorMessage="errors.has('newPassword')"
          :errorMessage="errors.first('newPassword')"
          radius="20px"
        ></t-input>

        <!-- ボタン類 -->
        <div class="row-buttons">
          <div
            @click="SaveNewPassword"
            v-bind:class="{disable:IsLoading|| errors.has('newPassword')  }"
            class="button-edit"
          >
            <i class="fas fa-share-square"></i>
            この新しいパスワードに決めた！
          </div>
        </div>
        <!-- {{debug_log}} -->
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Get the URL parameter value
 *
 * @param  name {string} パラメータのキー文字列
 * @return  url {url} 対象のURL文字列（任意）
 */
function GetParameterByName(name) {
  var url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

import TInput from "../TInput";
import Tloading from "../TLoading";

export default {
  name: "ResetPasswordPage",
  components: {
    TInput,
    "t-loading": Tloading
  },

  data() {
    return {
      IsLoading: false,
      message: "",
      ShowResultOK: false,
      ruleForm: {
        newPassword: ""
      },
      mode: "",
      actionCode: "",
      apiKey: "",
      continueUrl: "",
      lang: "",
      accountEmail: "",
      debug_log: "",
      errorMessageTitle: "",
      errorMessage: "",
      IsCheckingData: false, //ユーザー確認中
      IsShowResetPasswordContent: false,
      IsShowErrorContent: false
    };
  },
  beforeMount() {
    this.ExecActionFromURL();
  },
  mounted() {
    this.ruleForm.newPassword = "";
    this.ShowResultOK = false;
  },
  methods: {
    //========================
    //アクション実行：クエリパラメータから（初回に実行）
    //========================
    ExecActionFromURL() {
      this.IsCheckingData = true;
      // 現在のクエリからパラメータを取得
      // 完了するユーザー管理アクション
      this.mode = GetParameterByName("mode");
      // リクエストを識別し、検証するためのワンタイム コード
      this.actionCode = GetParameterByName("oobCode");
      // 便宜のために提供される Firebase プロジェクトの API キー
      this.apiKey = GetParameterByName("apiKey");
      // (Optional) URL を使用して状態をアプリに戻す方法を提供するオプションの URL。
      this.continueUrl = GetParameterByName("continueUrl");
      // (Optional) Get the language code if available.
      this.lang = GetParameterByName("lang") || "ja";

      this.debug_log =
        "beforeMout:mode=" +
        this.mode +
        ",actionCode=" +
        this.actionCode +
        ",apiKey=" +
        this.apiKey +
        ",continueURL=" +
        this.continueUrl +
        ",lang=" +
        this.lang;

      //modeの指定がない場合:処理抜ける
      if (this.mode === null) {
        this.IsCheckingData = false;
        return;
      }

      // Handle the user management action.
      switch (this.mode) {
        case "resetPassword":
          // Display reset password handler and UI.
          this.StartResetPasswordPage(this.actionCode, this.continueUrl, this.lang);
          return;
          break;
        case "recoverEmail":
          // Display email recovery handler and UI.
          //handleRecoverEmail(auth, actionCode, lang);
          break;
        case "verifyEmail":
          // Display email verification handler and UI.
          //handleVerifyEmail(auth, actionCode, continueUrl, lang);
          break;
        default:
        // Error: invalid mode.
      }
      
      //assert:このステートメントが実行されるということは、クエリパラメーターがおかしい
      this.IsCheckingData = false;
      this.ShowErrorPage(
              "エラー",
              "このパスワードリセットのお願いは有効期限が切れてるよ！もう一度"
            );
    },
    //========================
    //リセットパスワードページ表示前チェック処理
    //========================
    StartResetPasswordPage(actionCode, continueUrl, lang) {
      var me = this;

      // コードの認証
      firebase
        .auth()
        .verifyPasswordResetCode(actionCode)
        .then(function(email) {
          //actionCode認証OK
          me.accountEmail = email;
          me.IsCheckingData = false;
          me.IsShowResetPasswordContent = true; //リセットパスワードページを表示
        })
        .catch(function(error) {
          // Invalid or expired action code. Ask user to try to reset the password
          // again.
          //TODO:エラー結果を表示
          if (error.code === "auth/invalid-action-code") {
            me.ShowErrorPage(
              "有効期限が切れています",
              "このパスワードリセットのお願いは有効期限が切れてるよ！"
            );
            return;
          }

          //think: invalid-action-code以外のエラーで何が飛んでくるんだろう？
          me.ShowErrorPage("エラー", error.message);
        });
    },
    //========================
    //エラーページを表示する
    //========================
    ShowErrorPage(title, msg) {
      this.errorMessageTitle = title;
      this.errorMessage = msg;
      this.IsLoading = false;
      this.IsCheckingData = false;
      this.IsShowResetPasswordContent = false;
      this.IsShowErrorContent = true;
    },
    //========================
    //ログイン画面へ戻る
    //========================
    GoBack() {
      this.$router.push("/login");
    },
    //========================
    //新しいパスワードを保存（前処理）
    //========================
    SaveNewPassword() {
      //値の検証
      this.$validator
        .validate("newPassword")
        .then(result => {
          if (result) {
            this.SaveNewPasswordProcess(this.ruleForm.newPassword);
          }
        })
        .bind(this);
    },
    //========================
    //新しいパスワードを保存（本処理）
    //========================
    SaveNewPasswordProcess(newPassword) {
      this.IsLoading = true;
      //新しいパスワードに変更します。
      var me = this;
      firebase
        .auth()
        .confirmPasswordReset(this.actionCode, newPassword)
        .then(function(resp) {
          // Password reset has been confirmed and new password updated.
          me.IsLoading = false;

          //表示:完了画面の表示
          me.IsShowResetPasswordContent = false;
          me.ShowResultOK = true;
          
        })
        .catch(function(error) {
          //エラー表示
          me.ShowErrorPage("エラー", error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
//---------------
// ユーザー確認中表示
//---------------
.checking-data {
  color: #42b983;
  font-weight: 600;
  font-size: 24px;
  margin-top: 100px;
  & > i {
    margin-right: 18px;
  }
}

.profile-container {
  outline-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-main-content {
}

.ok-button {
  text-align: center;

  display: block;
  font-size: 22px;
  text-decoration: none;
  margin-top: 20px;
  & > i {
    margin-right: 8px;
  }
  &:hover {
    color: coral;
  }

  color: #42b983;
  cursor: pointer;
}

.back {
  text-align: left;

  display: inline-block;
  font-size: 22px;
  text-decoration: none;
  margin-bottom: 8px;
  & > i {
    margin-right: 8px;
  }
  &:hover {
    color: coral;
  }

  color: #42b983;
  cursor: pointer;
}

.result-ok-content {
  margin-top: 20px;
  color: #42b983;
  font-size: 16px;
  font-weight: 600;
  text-align: center;

  & > i {
    display: block;
    font-size: 80px;
    margin-bottom: 40px;
  }
}

//---------------
// :無効時のスタイル
//---------------
.disable {
  opacity: 0.3;
  cursor: default;
  pointer-events: none; // クリック、タッチを無効化
  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.loading-container {
  position: relative;
  .loading-item {
    position: absolute;
    top: 40px;
    left: 80px;
    z-index: 999;
    transform: scale(1);
  }
}

.row-input {
  width: 600px;
}

h1,
h2 {
  font-weight: 800;
  display: inline-block;
  //縁取り文字
  color: yellow;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #666;

  & > span {
    display: block;
    text-align: center;
    font-weight: normal;
    font-size: 16px;
  }
}

//--------------
//ボタン:送信する
//--------------
.button-edit {
  cursor: pointer;
  margin-top: 5px;
  color: #fff;
  display: inline-block;
  border: 1px solid #42b983;
  background: #42b983;
  text-align: center;
  border-radius: 20px;
  padding-top: 10px;
  padding-bottom: 9px;
  padding-left: 20px;
  padding-right: 18px;
  height: 25px;
  vertical-align: middle;
  letter-spacing: 32x;
  font-weight: 600;
  font-size: 16px;
  box-shadow: 0px 3px #228659;

  &.cancel {
    background: #fff;
    color: #42b983;
  }

  &:hover {
    opacity: 0.8;
  }

  & > i {
    margin-right: 5px;
    font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ResetPasswordPage.vue